import styled from 'styled-components'

export const ShowOnSmall = styled.div`
  display: none;
  @media (max-width: 900px) {
    display: block;
  }
`

export const ShowOnLarge = styled.div`
  display: block;
  height: 100%;
  @media (max-width: 900px) {
    display: none;
  }
`
